import {LitElement, html, css, TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import {sharedStyles} from "./SharedStyle";
import {deleteCookie, getCookie} from "../services/cookieService";
import {Save, SavePopup} from "./SavePopup";
import {getSaves, loadSave, resetCurrentPlayerSession} from "../services/routeService";

interface MenuItem {
    label: string;
}

const PlayLabel: string = "Play";
const LoginLabel: string = "Login";
const RegisterLabel: string = "Register";
const LogoutLabel: string = "Logout";

@customElement("menu-screen")
export class MenuScreen extends LitElement {
    @property({type: Array}) public items: MenuItem[] = [];
    @property({type: Array}) public saves: Save[] = [];

    public constructor() {
        super();
        this._updateMenuItems();
        void this._getSaves();
    }


    public static styles = [
        sharedStyles,
        css`
            .menu {
                font-family: Arial, sans-serif;
                border-radius: 5px;
                padding: 10px;
                width: 250px;
                margin-bottom: 40%;
            }

            .menu h2 {
                margin: 0 0 10px 0;
                font-size: 1.7em;
                color: #00FF00;

            }

            .menu ul {
                list-style-type: none;
                padding: 0;
                margin: 0;
            }

            .menu li {
                cursor: pointer;
                padding: 5px 10px;
                margin-bottom: 5px;
                border-radius: 3px;
                color: #00FF00;
            }

            .menu li:hover {
                color: #00c000;
                transform: scale(1.2);
                background-color: #101010;
            }
        `];

    public render(): TemplateResult<1> {
        return html`
            <div class="menu">
                <h2 class="typewriter">Lost lands</h2>
                <ul role="menu">
                    ${this.items.map(
                        (item) =>
                            html`
                                <li role="menuitem" tabindex="0"
                                    @click=${async (): Promise<void> => await this._handleItemClick(item.label)}
                                    @keydown=${async (e: KeyboardEvent): Promise<void> => await this._handleItemKeydown(e, item.label)}>
                                    ${item.label}
                                </li>`
                    )}
                </ul>
            </div>

            <save-popup .saves=${this.saves} @save-selected=${this._handleSaveSelected}></save-popup>
        `;
    }

    private async _handleSaveSelected(e: CustomEvent): Promise<void> {
        const selectedSave: any = e.detail;
        const cookie: string = getCookie("access_token")!;

        if (selectedSave.name === "New game" || !cookie) {
            await resetCurrentPlayerSession();
            document.location.pathname = "game.html";
        }

        await loadSave(selectedSave.save_id, cookie);
        document.location.pathname = "game.html";
    }

    private _updateMenuItems(): void {
        this.items = [{label: PlayLabel}];
        const access_token: string | null = getCookie("access_token");

        if(access_token !== null){
            this.items.push({label: LogoutLabel});
        }

        if(access_token === null){
            this.items.push({label: LoginLabel});
            this.items.push({label: RegisterLabel});
        }

        this.requestUpdate(); // Request a re-render of the component
    }

    private async _getSaves(): Promise<void> {
        const access_token: string | null = getCookie("access_token");
        if(access_token){
            this.saves = await getSaves(access_token);
            this.saves.splice(0, 0, {name: "New game", save_id: "0"});
        }
    }

    private async _handleItemClick(label: string): Promise<void> {
        switch (label) {
            case PlayLabel:
                if (getCookie("access_token") === null) {
                    await resetCurrentPlayerSession();
                    document.location.pathname = "game.html";
                } else {
                    const popup: SavePopup | null | undefined = this.shadowRoot?.querySelector("save-popup");
                    if (popup) {
                        popup.style.display = "block";
                    }
                }
                break;
            case LoginLabel:
                document.location.pathname = "login.html";
                break;
            case LogoutLabel:
                deleteCookie("access_token");
                document.location.pathname = "index.html";
                break;
            case RegisterLabel:
                document.location.pathname = "register.html";
                break;

        }
    }

    private async _handleItemKeydown(e: KeyboardEvent, label: string): Promise<void> {
        if (e.key === "Enter" || e.key === " ") {
            await this._handleItemClick(label);
        }
    }
}
